import React from "react";

const Home = () => {
  const loggedInUser = localStorage.getItem("username"); // Retrieve the logged-in user's ID

  return (
    <div className="content">
      <h2>Welcome to EquityFinX</h2>
      <p>Manage your crypto portfolio with ease.</p>
      {loggedInUser === "74fa9d1fe62900729c057e37f4241c2217ea678501c60334808391161a01507b" || 
        loggedInUser === "3867deec0cc9d459e47970652ecf123f4671b667352c8fb992a00990402ec074" 
        ? (
        <p style={{ color: "green", fontWeight: "bold" }}>
          Crypto Bot is activated for your account. Enjoy automated insights!
        </p>
      ) : (
        <p style={{ color: "gray" }}>
          Crypto Bot is not activated for your account.
        </p>
      )}
    </div>
  );
};

export default Home;
